import PrintableProject from '@/components/ProjectDetail/PrintableProject';
import { useProjects } from '@/services/project/hooks';
import { Box, GlobalStyle, LightMode } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

function PrintProjectPage() {
  const { id: projectId } = useParams();

  const { data: projects } = useProjects();

  const categoryId = useMemo(
    () => projects?.project.find((p) => projectId === p.id)?.categoryId ?? '',
    [projectId, projects?.project],
  );

  return (
    <LightMode>
      <GlobalStyle />
      <Helmet>
        <title>Print a Project</title>
      </Helmet>
      {projectId && categoryId && (
        <Box as="main" overflowY="scroll" width="full" maxWidth="full" height="100vh" backgroundColor="white">
          <PrintableProject categoryId={categoryId} projectId={projectId} />
        </Box>
      )}
    </LightMode>
  );
}

export default PrintProjectPage;
